/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ecash_chain_max_tps_explanation = () => `eCash operates as a PoW network, where block times vary significantly due to the nature of the mining process. In some cases, when a miner solves the cryptographic puzzle unusually quickly, a new block can be created in just seconds.<br /><br />This variability explains why eCash’s <strong>Max TPS (1 block)</strong> can exceed its <strong>Max Theoretical TPS</strong>.`
